import {
    CartesianGrid,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';
import './Analytics.scss';

export function formatDayChartLabel(date) {
    if (!date) return date;

    return new Date(`${date}T12:00:00`).toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
    });
}

export default function MetricLineChart({
    data,
    height = 280,
    emptyText = 'Нет данных за период',
}) {
    const chartData = (data || []).map((row) => ({
        ...row,
        label: row.label || formatDayChartLabel(row.date),
    }));

    if (chartData.length === 0) {
        return <p className="analytics-chart__empty">{emptyText}</p>;
    }

    return (
        <ResponsiveContainer width="100%" height={height}>
            <LineChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border-subtle)" />
                <XAxis dataKey="label" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
                <Tooltip formatter={(value) => [value, 'Событий']} />
                <Line
                    type="monotone"
                    dataKey="count"
                    stroke="var(--color-accent)"
                    strokeWidth={2}
                    dot={{ r: 3 }}
                />
            </LineChart>
        </ResponsiveContainer>
    );
}
